import { DateRange, Nillable } from '@web/utils';
import { MultimediaType } from '../../shared/enums/multimedia-type';

export class AdminMultimediaGridFilter {
  public constructor(
    public readonly title?: Nillable<string>,
    public readonly createdAt?: Nillable<DateRange>,
    public readonly type?: Nillable<MultimediaType[]>,
  ) {}

  public static fromPartial(
    partial?: Partial<AdminMultimediaGridFilter>,
  ): AdminMultimediaGridFilter {
    return new AdminMultimediaGridFilter(
      partial?.title,
      partial?.createdAt,
      partial?.type,
    );
  }

  public static copyOf(
    filter: AdminMultimediaGridFilter,
    overrides?: Partial<AdminMultimediaGridFilter>,
  ): AdminMultimediaGridFilter {
    const data = { ...filter, ...overrides };

    return new AdminMultimediaGridFilter(data.title, data.createdAt, data.type);
  }
}
